var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$vuetify.breakpoint.smAndUp)?_c('v-switch',{staticClass:"ma-0",attrs:{"label":this.multipleSelection
      ? _vm.$t('downtime.disableAssignment')
      : _vm.$t('downtime.enableAssignment')},model:{value:(_vm.multipleSelection),callback:function ($$v) {_vm.multipleSelection=$$v},expression:"multipleSelection"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }